import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/v1/[communitySlug]/propose/_components/EventProposeModalWrapperPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SmallRiverLoading"] */ "/vercel/path0/src/components/themed/RiverLoading.tsx");
